// Stripe Payment Service
// Uses Stripe Payment Links (no backend required)
// Documentation: https://stripe.com/docs/payment-links

// Configuration
const STRIPE_CONFIG = {
  // Stripe Payment Link URL - Create one at: https://dashboard.stripe.com/payment-links
  // Set it as a donation/variable amount link
  paymentLinkBase:
    (typeof import.meta !== 'undefined' &&
      import.meta.env?.VITE_STRIPE_PAYMENT_LINK) ||
    'https://buy.stripe.com/5kQ00j0FVbfKemV3472VG00',
  publishableKey:
    (typeof import.meta !== 'undefined' &&
      import.meta.env?.VITE_STRIPE_PUBLIC_KEY) ||
    '',
}

interface DonationData {
  amount: number
  currency: string
  donorName: string
  donorEmail: string
  companyName?: string
}

export class StripeService {
  private paymentLinkBase: string
  private publishableKey: string

  constructor(paymentLinkBase: string, publishableKey: string) {
    this.paymentLinkBase = paymentLinkBase
    this.publishableKey = publishableKey
  }

  isConfigured(): boolean {
    return !!this.paymentLinkBase && this.paymentLinkBase.startsWith('https://')
  }

  /**
   * Redirect to Stripe Payment Link or Checkout
   */
  async createCheckoutSession(
    data: DonationData,
  ): Promise<{ success: boolean; error?: string }> {
    console.log('💳 Stripe payment initiated:', data)

    // Use Stripe Payment Link (recommended, no backend)
    if (this.paymentLinkBase) {
      const params = new URLSearchParams({
        prefilled_email: data.donorEmail,
      })

      const paymentUrl = `${this.paymentLinkBase}?${params.toString()}`
      console.log('🔗 Redirecting to Stripe Payment Link:', paymentUrl)

      // Use location.href instead of window.open to avoid popup blockers
      window.location.href = paymentUrl

      return { success: true }
    }

    return {
      success: false,
      error:
        "Service de paiement Stripe non configuré. Contactez l'administrateur.",
    }
  }

  private async loadStripe(): Promise<any> {
    if ((window as any).Stripe) {
      return (window as any).Stripe(this.publishableKey)
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = 'https://js.stripe.com/v3/'
      script.async = true
      script.onload = () => {
        if ((window as any).Stripe) {
          resolve((window as any).Stripe(this.publishableKey))
        } else {
          reject(new Error('Stripe failed to load'))
        }
      }
      script.onerror = () => reject(new Error('Failed to load Stripe.js'))
      document.head.appendChild(script)
    })
  }
}

// Export singleton instance
export const stripeService = new StripeService(
  STRIPE_CONFIG.paymentLinkBase,
  STRIPE_CONFIG.publishableKey,
)
